export default (elementId) => {
    const element = typeof elementId === 'string'
        ? document.getElementById(elementId)
        : elementId;
    if (!element)
        return false;
    const rect = element.getBoundingClientRect();
    return (rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <=
            (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth) &&
        rect.bottom > rect.top &&
        rect.right > rect.left);
};
//# sourceMappingURL=isElementVisible.js.map